(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lookbook-hotspots"] && !Shopify.designMode) return;
  try {
    
class LookbookHs extends HTMLElement {
  connectedCallback() {
    this._slides = Array.from(this.querySelectorAll('.lookbook-hs__slide'));
    this._dots = Array.from(this.querySelectorAll('.lookbook-hs__dot'));
    this._n = 0;
    this.querySelector('.lookbook-hs__arrow--prev')
      ?.addEventListener('click', () => this._go(this._n - 1));
    this.querySelector('.lookbook-hs__arrow--next')
      ?.addEventListener('click', () => this._go(this._n + 1));
    this._dots.forEach((d, i) => d.addEventListener('click', () => this._go(i)));
  }
  _go(n) {
    const L = this._slides.length;
    n = ((n % L) + L) % L;
    this.querySelectorAll('.hotspot-dialog[open]').forEach(d => d.close());
    this._slides.forEach((s, i) => s.classList.toggle('is-active', i === n));
    this._dots.forEach((d, i) => d.classList.toggle('is-active', i === n));
    this._n = n;
  }
}
customElements.get('lookbook-hs') || customElements.define('lookbook-hs', LookbookHs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
    
class LookbookCarousel extends HTMLElement {
  connectedCallback() {
    this._thumbs = Array.from(this.querySelectorAll('.lookbook__thumb'));
    this._panels = Array.from(this.querySelectorAll('.lookbook__panel'));
    this._thumbs.forEach((t, i) => t.addEventListener('click', () => this._activate(i)));
  }
  _activate(index) {
    this._thumbs.forEach((t, i) => {
      t.classList.toggle('is-active', i === index);
      t.setAttribute('aria-selected', String(i === index));
    });
    this._panels.forEach((p, i) => {
      p.classList.toggle('is-active', i === index);
      i === index ? p.removeAttribute('hidden') : p.setAttribute('hidden', '');
    });
  }
}
if (!customElements.get('lookbook-carousel')) {
  customElements.define('lookbook-carousel', LookbookCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-look"] && !Shopify.designMode) return;
  try {
    
class StlSection extends HTMLElement {
  connectedCallback() {
    this._hs = Array.from(this.querySelectorAll('.stl-hs'));
    this._hover = window.matchMedia('(hover: hover)').matches;
    this._open = null;
    this._t = null;
    this._bind();
  }

  _bind() {
    this._hs.forEach(btn => {
      const popup = this.querySelector('#' + btn.dataset.popup);
      if (!popup) return;

      btn.addEventListener('click', e => {
        e.stopPropagation();
        popup.classList.contains('is-open') ? this._close() : this._show(btn, popup);
      });

      if (this._hover) {
        btn.addEventListener('mouseenter', () => {
          clearTimeout(this._t);
          this._show(btn, popup);
        });
        btn.addEventListener('mouseleave', e => {
          if (!popup.contains(e.relatedTarget)) {
            this._t = setTimeout(() => this._close(), 120);
          }
        });
        popup.addEventListener('mouseenter', () => clearTimeout(this._t));
        popup.addEventListener('mouseleave', () => {
          this._t = setTimeout(() => this._close(), 120);
        });
      }

      popup.querySelector('.stl-popup__x')?.addEventListener('click', e => {
        e.stopPropagation();
        this._close();
      });
    });

    document.addEventListener('click', () => this._close());
    this.addEventListener('click', e => e.stopPropagation());
  }

  _show(btn, popup) {
    this._close();
    this._pos(btn, popup);
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    btn.setAttribute('aria-expanded', 'true');
    this._open = { popup, btn };
  }

  _close() {
    if (!this._open) return;
    const { popup, btn } = this._open;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    btn.setAttribute('aria-expanded', 'false');
    this._open = null;
  }

  _pos(btn, popup) {
    const frame = btn.closest('.stl__frame');
    const fr = frame.getBoundingClientRect();
    const br = btn.getBoundingClientRect();
    const PW = 220, OFFSET = 14;
    const cx = br.left + br.width / 2 - fr.left;
    const cy = br.top  + br.height / 2 - fr.top;

    /* Make popup briefly visible to measure its height */
    popup.style.visibility = 'hidden';
    popup.style.display = 'block';
    const ph = popup.offsetHeight || 90;
    popup.style.display = '';
    popup.style.visibility = '';

    /* Vertical: center on hotspot, clamped inside frame */
    let top = cy - ph / 2;
    top = Math.max(4, Math.min(top, fr.height - ph - 4));
    popup.style.top  = top + 'px';
    popup.style.bottom = 'auto';

    /* Horizontal: right if room, else left */
    if (cx + OFFSET + PW <= fr.width) {
      popup.style.left  = (cx + OFFSET) + 'px';
      popup.style.right = 'auto';
    } else {
      popup.style.right = (fr.width - cx + OFFSET) + 'px';
      popup.style.left  = 'auto';
    }
  }
}
customElements.get('stl-section') || customElements.define('stl-section', StlSection);

  } catch(e) { console.error(e); }
})();
})();
